import { APIError } from '../errors/app-errors.js';

export const HttpService = {
  send: async (url, method, headers, body) => {
    const response = await fetch(url, {
      method,
      headers,
      body
    });
    const data = await response.json();
    if (response.status !== 200) throw new APIError(response.status, data.message);
    return data;  
  }
}